<div id="studyAreaTable" class="list-container">
    <h6 class="headline-6">User Created Study Areas</h6>
    <div class="list-item-searchbar basin-mb-4 basin-mt-4">
        <basin-searchbox [(searchString)]="searchString" (searchStringChange)="searchStringChange($event)"
            class="basin-width-100"></basin-searchbox>
    </div>

    <div class="list-item-wrapper basin-overflow-y-auto" [ngClass]="parentClassName">
        <div *ngIf="isClickable">
            <a class="list-item-container basin-display-flex basin-mb-2 basin-pt-2 basin-pl-2"
                *ngFor="let listItem of licenseStudyAreas | searchPipe: searchString: 'studyAreaName'"
                (click)="onStudyAreaClick(listItem)">
                <div class="list-item-text-box">
                    <div class="list-item-left-section-box basin-width-100">
                        <div
                            class="basin-body basin-font-weight-600 line-height-normal primary-line basin-font-primary">
                            {{listItem.studyAreaName}}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-font-primary">
                            {{ listItem.areaMeasurement }}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-mt-1 basin-font-primary">
                            {{listItem.creationTimestamp | date: 'dd/MM/yyyy'}}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-font-primary">
                            Created By: {{ listItem.firstName }} {{ listItem.lastName }}
                        </div>
                    </div>
                </div>
            </a>
        </div>

        <div *ngIf="!isClickable">
            <div class="list-item-container basin-display-flex basin-mb-2 basin-pt-2 basin-pl-2"
                *ngFor="let listItem of licenseStudyAreas | searchPipe: searchString: 'studyAreaName'">
                <div class="list-item-text-box">
                    <div class="list-item-left-section-box basin-width-100">
                        <div
                            class="basin-body basin-font-weight-600 line-height-normal primary-line basin-font-primary">
                            {{listItem.studyAreaName}}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-font-primary">
                            {{ listItem.areaMeasurement }}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-mt-1 basin-font-primary">
                            {{listItem.creationTimestamp | date: 'dd/MM/yyyy'}}
                        </div>

                        <div
                            class="sub-line secondary-line basin-display-flex basin-align-items-center basin-font-primary">
                            Created By: {{ listItem.firstName }} {{ listItem.lastName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>